/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";
// import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";

function Services() {
  return (
    <MKBox component="section" py={6} mx={-2}>
      <Container>
        <Grid item md={6} sx={{ ml: 0, mb: { xs: 2, md: 5 } }}>
          <MKTypography variant="h2">OUR SERVICES</MKTypography>
        </Grid>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12} md={4}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Residential Plumbing"
                description="Our residential plumbing services handle everything from regular upkeep to urgent repairs. We make sure your home's plumbing runs smoothly, ensuring a safe and comfortable space for you and your family."
              />
            </MKBox>
          </Grid>

          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Commercial Plumbing"
                description="We provide complete commercial plumbing solutions designed to meet the specific demands of businesses. Our expert services ensure your plumbing systems stay efficient and dependable, keeping your operations running smoothly."
              />
            </MKBox>
          </Grid>

          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Emergency Services"
                description="We understand that plumbing emergencies can happen at any time. That's why we provide prompt and efficient emergency plumbing services to address urgent issues and prevent further damage."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Leak Detection"
                description="Our team is skilled in concealed water pipe leak detection using a advanced technologies to pinpoint leaks in pipes hidden behind walls, under floors, or underground. Common methods include ultrasonic leak detection, which uses high-frequency sound waves. This method is effective for detecting concealed leaks in various locations, including walls, floors, and underground pipes. It's also minimally disruptive and can assist in narrowing down potential leak areas. The effectiveness can vary depending on the pipe material, soil composition, and the size of the leak."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Water Heater Installation / Replacement"
                description="We provide expert water heater installation to ensure you have reliable hot water when you need it. Our team handles the setup with precision and efficiency."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Drain Cleaning"
                description="Keep your drains clean and clear with our professional drain cleaning services. We eliminate clogs, buildup, and debris to prevent blockages and ensure your plumbing system functions efficiently."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Repairs, Replacements & Installation"
                description="From fixing minor leaks to installing new fixtures, we offer a full range of repair, replacement, and installation services to keep your plumbing system functioning perfectly."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Electrical Repair & Maintenance"
                description="We also provide electrical repair and maintenance services, ensuring all components work safely and efficiently."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <MKBox
              sx={{
                overflow: "hidden",
                transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
                transformOrigin: "50% 0",
                backfaceVisibility: "hidden",
                willChange: "transform, box-shadow",
                transition: "transform 200ms ease-out",

                "&:hover": {
                  transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
                },
              }}
            >
              <FilledInfoCard
                color="info"
                title="Pipe Replacement Work"
                description="We specialize in pipe replacement services, upgrading old cast iron or copper pipes to durable UPVC or stainless steel. Whether it’s partial or full repiping, we ensure your plumbing infrastructure is modern and reliable."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Services;
